import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-product-icon-价格分析",
  "use": "icon-product-icon-价格分析-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-product-icon-价格分析\">\n<path d=\"M19.6848 11.8251L10.6305 20.8794L3.4353 13.6842L12.4896 4.62985L19.6848 4.62985L19.6848 11.8251ZM19.7556 11.7543L19.7554 11.7546L19.7556 11.7543Z\" stroke=\"currentColor\" stroke-width=\"1.45012\" />\n<circle cx=\"14.218\" cy=\"10.0967\" r=\"1.99952\" stroke=\"currentColor\" stroke-width=\"1.45012\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol